import React, { useState } from "react";
import { CloseIcon } from "frontend/icons/close";
import { ShortenTextButton } from "./shorten-text-button";
import { ChangeToneButton } from "./change-tone-button";
import { TranslateButton as TranslateButtonComponent } from "./translate-button";
import { GrammarFixerButton } from "./grammar-fixer-button";
import style from "./ai-edits-panel.module.css";
import { VisalizeBoardIcon } from "frontend/icons/ai";

interface AIEditsPanelProps {
  onClose?: () => void;
  selectedElementIds: string[];
}

export function AIEditsPanel({ onClose, selectedElementIds }: AIEditsPanelProps): React.ReactElement {
  const [error, setError] = useState<string | null>(null);

  return (
    <div className={style.panel}>
      <div className={style.header}>
        <div className={style.headerContent}>
          <VisalizeBoardIcon />
          <h3>AI Edits</h3>
        </div>
        <button className={style.closeButton} onClick={onClose} aria-label="Close panel">
          <CloseIcon />
        </button>
      </div>

      <div>
        <p className={style.description}>Transform your text with AI-powered editing options</p>

        {error && <div className={style.error}>{error}</div>}

        <div className={style.buttonsList}>
          <ShortenTextButton selectedElementIds={selectedElementIds} onClose={onClose} onError={setError} />
          <GrammarFixerButton selectedElementIds={selectedElementIds} onClose={onClose} onError={setError} />
          <ChangeToneButton selectedElementIds={selectedElementIds} onClose={onClose} onError={setError} />
          <TranslateButtonComponent selectedElementIds={selectedElementIds} onClose={onClose} onError={setError} />
        </div>
      </div>
    </div>
  );
}
